import { Box } from "@mui/material";
import React from "react";
import CupIco from "../../../assets/icons/CupIco";
import CommonLinearProgress from "../../../component/Linearprogress";

const AcheivementBar = ({ percentage = 0, width = "80%" }) => {
  return (
    <Box
      sx={{
        width: width || "100%",
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <CommonLinearProgress
        variant="determinate"
        value={percentage}
        height={"12px"}
        borderRadius={"10px"}
        backgroundColor={"#E0E0E0"}
        barbackgroundColor={"#47CD89"}
      />
      {/* <Box
        sx={{
          position: "absolute",
          right: 0,
          // left: "10px",
          transform: "translateX(50%)",
          marginLeft: "10px",
        }}
      > */}
      <CupIco filled fill={percentage !== 100 ? "#D5DADD" : undefined} />
      {/* </Box> */}
    </Box>
  );
};

export default AcheivementBar;
